import { JswCollaborate } from "./components";

export const JswCollaborateSection = () => {
    const options = [
        {
            title: "⚡ Never lose sight of the goal",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-1.webp",
            description:
                "Break down complex, cross-functional work into easy to manage plans that ladder into company goals."
        },
        {
            title: "Automatically manage every update",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-2.webp",
            description:
                "Stay aligned and simplify stakeholder communication with comments, approvals, task progress notifications and more."
        },
        {
            title: "Work together like never before",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-3.webp",
            description:
                "From synced software release dates to cross project automations, Jira seamlessly connects teams that build software with those who launch and support it."
        },
        {
            title: "Make every launch a success",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/collaborate-4.webp",
            description:
                "Get visibility into project progress, understand risks, and surface insights to help you deliver on budget and on time."
        }
    ];

    return (
        <JswCollaborate
            options={options}
            heading="Collaborate to deliver projects as one team"
        />
    );
};
JswCollaborateSection.displayName = "JswCollaborateSection";
